import { useCallback, useEffect, useState } from "react";
import {
  getOperationOrdersAveragePreparationTime,
  getOperationOrdersSalesPrediction,
} from "../api/xRay";
import { getPreparingOrdersMatrix } from "../api/shipping";

const useOperationData = (show, userId) => {
  const [loading, setLoading] = useState(false);
  const [averagePreparationTime, setAveragePreparationTime] = useState(0);
  const [predictedOrdersNextHour, setPredictedOrdersNextHour] = useState(0);
  const [error, setError] = useState(null);
  const [showWelcome, setShowWelcome] = useState(false);

  const loadData = useCallback(async () => {
    if (!show) return;

    try {
      setLoading(true);

      const res = await getPreparingOrdersMatrix();
      console.log("PREPARING MATRIX", res.data);

      const {
        data: { predicted_orders_next_hour },
      } = await getOperationOrdersSalesPrediction();

      setPredictedOrdersNextHour(predicted_orders_next_hour);

      const { data } = await getOperationOrdersAveragePreparationTime();
      const timeInMinutes = data.average_time / 60;
      setAveragePreparationTime(timeInMinutes.toFixed(2));

      const completedUsers =
        JSON.parse(localStorage.getItem("operationDataWelcomeSlapie")) || [];
      setShowWelcome(!completedUsers.includes(userId));
    } catch (err) {
      console.log(err);
      setError("Failed to fetch operation data");
    } finally {
      setLoading(false);
    }
  }, [show, userId]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return {
    loading,
    averagePreparationTime,
    error,
    showWelcome,
    setShowWelcome,
    predictedOrdersNextHour,
  };
};

export default useOperationData;
